import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const iguatemiTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#c99868',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#f58220',
    },
  },
};
